var _g, _rect, _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _ellipse3, _ellipse4, _rect2, _path6, _rect3, _path7, _path8, _rect4, _rect5, _rect6, _path9, _rect7, _path10, _rect8, _path11, _path12, _path13, _path14, _path15, _rect9, _rect10, _ellipse5, _ellipse6, _ellipse7, _path16, _rect11, _rect12, _rect13, _path17, _path18, _rect14, _path19, _path20, _path21, _path22, _path23, _path24, _ellipse8, _ellipse9, _ellipse10, _path25, _path26, _path27, _ellipse11, _ellipse12, _path28, _ellipse13, _ellipse14, _path29, _path30, _path31, _path32, _path33, _path34, _ellipse15, _path35, _path36, _path37, _ellipse16, _path38, _path39, _path40, _path41, _path42, _path43, _rect15, _rect16, _path44, _path45, _rect17, _path46, _rect18, _ellipse17, _path47, _path48, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _path49, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _path50;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFte5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.6623 428.042C83.6623 428.042 -7.10853 319.982 20.0824 292.327C47.2734 264.671 92.9713 294.858 85.1433 264.037C77.3153 233.216 46.1244 203.318 58.7293 179.929C73.8603 151.855 118.136 174.634 139.577 184.464C179.438 202.741 223.61 204.768 208.302 179.208C192.994 153.647 152.918 128.673 167.454 114.105C187.236 94.2819 296.016 167.665 342.571 225.13C370.434 259.522 390.741 235.591 387.92 213.496C386.127 199.452 366.391 170.474 387.094 157.358C407.051 144.715 453.66 183.894 469.493 208.085C510.951 271.428 443.074 427.426 443.074 427.426L83.6623 428.042Z",
    fill: "#C5CEDA"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61.1074,
    y: 111.145,
    width: 101.185,
    height: 67.2147,
    fill: "#4A90E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261.072 177.998V232.224H122.053V130.957H261.072V177.998",
    fill: "#E1E1E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M261.073 138.389V146.954H122.053V130.959H261.073V138.389",
    fill: "#4A90E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.478 130.264H138.037V232.227H122.053V130.264H129.478",
    fill: "#055CC0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.541 233.739H263.525V128.752H120.541V233.739ZM260.503 230.714H123.564V131.777H260.503V230.714Z",
    fill: "#0134A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.541 233.739H263.525V128.752H120.541V233.739ZM260.503 230.714H123.564V131.777H260.503V230.714Z",
    fill: "#0134A0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.045,
    cy: 157.444,
    rx: 3.95499,
    ry: 3.95769,
    fill: "#8896AA"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.045,
    cy: 169.819,
    rx: 3.95499,
    ry: 3.95769,
    fill: "#E6E6E8"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.045,
    cy: 182.195,
    rx: 3.95499,
    ry: 3.95769,
    fill: "#E6E6E8"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.045,
    cy: 194.57,
    rx: 3.95499,
    ry: 3.95769,
    fill: "#E6E6E8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 145.213,
    y: 159.113,
    width: 23.9939,
    height: 38.0028,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.312 193.828H165.106V189.994H149.312V193.828ZM164.351 193.071H150.069V190.746H164.351V193.071Z",
    fill: "#055CC0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 173.606,
    y: 159.113,
    width: 23.9939,
    height: 38.0028,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.706 193.828H193.496V189.994H177.706V193.828ZM192.741 193.071H178.459L178.463 190.747H192.741V193.071Z",
    fill: "#055CC0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.457 174.036C180.487 176.524 182.913 178.145 185.603 178.145C189.275 178.14 192.25 175.163 192.254 171.488C192.254 168.796 190.634 166.369 188.148 165.339C185.662 164.308 182.801 164.878 180.898 166.782C178.996 168.686 178.427 171.549 179.457 174.036ZM179.703 171.492C179.703 168.232 182.345 165.588 185.603 165.588C188.862 165.588 191.503 168.232 191.503 171.492C191.503 174.753 188.862 177.396 185.603 177.396C182.345 177.396 179.703 174.753 179.703 171.492Z",
    fill: "#055CC0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 145.213,
    y: 204.729,
    width: 93.8778,
    height: 2.3486,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 145.213,
    y: 210.641,
    width: 93.8778,
    height: 2.3486,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 145.213,
    y: 216.553,
    width: 63.4929,
    height: 2.3486,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M181.416 204.173C181.423 204.273 181.372 204.368 181.286 204.42C181.245 204.466 181.193 204.5 181.135 204.52L175.743 205.93L173.729 211.142C173.662 211.297 173.508 211.395 173.34 211.393C173.176 211.383 173.036 211.269 172.993 211.11L169.493 199.442C169.461 199.305 169.508 199.16 169.615 199.068C169.722 198.975 169.871 198.949 170.003 199L181.203 203.803C181.351 203.862 181.44 204.015 181.416 204.173V204.173Z",
    fill: "#0134A0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 230.393,
    y: 159.113,
    width: 23.9939,
    height: 38.0028,
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.243 174.036C237.273 176.524 239.699 178.145 242.39 178.145C246.061 178.141 249.037 175.163 249.04 171.488C249.04 168.796 247.42 166.369 244.934 165.339C242.448 164.308 239.587 164.878 237.684 166.782C235.782 168.686 235.213 171.549 236.243 174.036ZM236.49 171.492C236.49 168.232 239.131 165.588 242.39 165.588C245.648 165.588 248.29 168.232 248.29 171.492C248.29 174.753 245.648 177.396 242.39 177.396C239.131 177.396 236.49 174.753 236.49 171.492Z",
    fill: "#055CC0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 201.999,
    y: 159.113,
    width: 23.9939,
    height: 38.0028,
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.098 193.828H221.898V189.994H206.098V193.828ZM221.137 193.071H206.859L206.855 190.747H221.137V193.071Z",
    fill: "#055CC0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.498 193.828H250.287L250.292 189.994H234.498V193.828ZM249.531 193.071H235.249V190.747H249.531V193.071Z",
    fill: "#055CC0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.852 174.036C208.882 176.523 211.307 178.145 213.998 178.145C217.67 178.141 220.646 175.163 220.65 171.488C220.65 168.796 219.029 166.369 216.543 165.339C214.058 164.308 211.197 164.878 209.294 166.782C207.392 168.685 206.823 171.548 207.852 174.036ZM208.098 171.492C208.098 168.232 210.74 165.588 213.998 165.588C217.257 165.588 219.898 168.232 219.898 171.492C219.898 174.753 217.257 177.396 213.998 177.396C210.74 177.396 208.098 174.753 208.098 171.492Z",
    fill: "#055CC0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M222.646 427.517H254.413V417.757H233.274L221.142 422.915C220.212 423.236 219.567 424.085 219.505 425.067V425.067C219.505 426.42 220.911 427.517 222.646 427.517Z",
    fill: "#192335"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M265.104 427.517H296.871V417.757H275.731L263.597 422.915C262.667 423.236 262.021 424.085 261.959 425.067V425.067C261.962 426.42 263.369 427.517 265.104 427.517Z",
    fill: "#192335"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 116.023,
    y: 232.226,
    width: 196.796,
    height: 8.46976,
    fill: "#0134A0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 116.023,
    y: 232.226,
    width: 196.796,
    height: 8.46976,
    fill: "#0134A0"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.752,
    cy: 293.485,
    rx: 11.28,
    ry: 11.2877,
    fill: "#AB9AF7"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 271.049,
    cy: 291.251,
    rx: 13.313,
    ry: 13.3221,
    fill: "#AB9AF7"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 314.237,
    cy: 291.255,
    rx: 13.313,
    ry: 13.3221,
    fill: "#AB9AF7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M328.209 277.933L327.556 291.255L327.524 291.908C327.176 299.005 321.324 304.579 314.224 304.577H271.072C263.972 304.579 258.12 299.005 257.772 291.908L257.74 291.255L257.087 277.933L328.209 277.933Z",
    fill: "#AB9AF7"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 77.6465,
    y: 238.509,
    width: 369.992,
    height: 10.5802,
    fill: "#0134A0"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 103.513,
    y: 438.961,
    width: 183.74,
    height: 1.45399,
    fill: "#293F51"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 311.621,
    y: 438.961,
    width: 93.9178,
    height: 1.45399,
    fill: "#293F51"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M109.562 248.123L108.576 257.525L89.8875 428.083H85.1436L99.1705 248.123H109.562V248.123Z",
    fill: "#0134A0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M408.13 248.123L409.117 257.525L427.804 428.083H432.548L418.522 248.123H408.13V248.123Z",
    fill: "#0134A0"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6211,
    y: 427.323,
    width: 470.399,
    height: 1.45399,
    fill: "#293F51"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.757 195.889H255.097V192.507H239.757V195.889ZM254.798 195.589H240.062L240.06 192.809H254.798V195.589Z",
    fill: "#055CC0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M276.861 318.193L219.566 318.434L218.675 282.263L275.81 277.097L276.861 318.193V318.193Z",
    fill: "#658FDF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M225.848 214.359L301.184 229.118L300.066 240.723L296.111 240.724L290.267 240.723L223.31 240.742L225.848 214.359V214.359Z",
    fill: "#C9DEF6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M300.07 240.719L301.188 229.114L296.115 228.12V240.72L300.07 240.719V240.719Z",
    fill: "#C9DEF6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M278.835 156.184H314.377V117.231C314.377 105.383 304.778 95.7784 292.938 95.7779V95.7779C281.5 95.7779 271.103 104.763 270.55 116.192L269.111 145.967C268.981 148.63 269.948 151.23 271.785 153.16C273.623 155.091 276.171 156.184 278.835 156.184Z",
    fill: "#E6BBA6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M305.404 186.953H296.563C291.609 186.953 287.592 182.934 287.592 177.976V146.281H314.371V177.977C314.371 182.934 310.355 186.953 305.401 186.953L305.404 186.953Z",
    fill: "#E6BBA6"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300.985,
    cy: 173.553,
    rx: 13.391,
    ry: 13.4001,
    fill: "#E6BBA6"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 219.806,
    cy: 293.485,
    rx: 11.28,
    ry: 11.2877,
    fill: "#4A90E2"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 219.806,
    cy: 293.485,
    rx: 11.28,
    ry: 11.2877,
    fill: "#658FDF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M256.56 418.401L238.695 292.84L208.57 294.608L227.648 418.401H256.56V418.401Z",
    fill: "#658FDF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M298.699 418.401L280.834 292.84L250.709 294.608L269.787 418.401H298.699V418.401Z",
    fill: "#658FDF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M334.259 277.933C334.265 282.499 333.387 287.023 331.674 291.255H265.724C260.355 277.945 263.503 262.711 273.706 252.623C283.909 242.535 299.169 239.569 312.404 245.101C325.639 250.633 334.258 263.58 334.259 277.933Z",
    fill: "#AB9AF7"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 298.696,
    cy: 277.933,
    rx: 9.75298,
    ry: 9.75964,
    fill: "#40327A"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 374.134,
    cy: 227.362,
    rx: 13.304,
    ry: 13.313,
    transform: "rotate(-4.699 374.134 227.362)",
    fill: "#C9DEF6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M313.988 201.9L366.56 238.312L383.676 218.088L339.084 172.247L313.988 201.9V201.9Z",
    fill: "#C9DEF6"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 325.09,
    cy: 185.851,
    rx: 19.5073,
    ry: 19.5179,
    transform: "rotate(-18.744 325.09 185.851)",
    fill: "#C9DEF6"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 313.083,
    cy: 239.401,
    rx: 7.80572,
    ry: 7.80357,
    transform: "rotate(-56.899 313.083 239.401)",
    fill: "#FF95A9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M305.812 235.986C305.357 238.311 303.548 240.132 301.228 240.601C298.908 241.071 296.534 240.095 295.213 238.13C293.892 236.165 293.884 233.597 295.193 231.623C296.502 229.65 298.87 228.66 301.193 229.115C302.716 229.413 304.059 230.304 304.925 231.593C305.791 232.882 306.11 234.462 305.812 235.986V235.986Z",
    fill: "#FF95A9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M309.494 246.335L297.376 240.062L301.192 229.115L314.582 231.737L309.494 246.335V246.335Z",
    fill: "#FF95A9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M236.354 229.977C234.941 237.189 227.953 241.89 220.746 240.477C213.539 239.065 208.84 232.073 210.25 224.861C211.66 217.648 218.646 212.945 225.854 214.355C229.317 215.032 232.369 217.059 234.339 219.989C236.308 222.919 237.033 226.512 236.354 229.977V229.977Z",
    fill: "#C9DEF6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M283.413 201.887L230.882 238.358L213.743 218.153L258.284 172.263L283.413 201.887V201.887Z",
    fill: "#C9DEF6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M283.416 201.886L239.799 232.167L221.306 210.356L258.282 172.26L283.416 201.886V201.886Z",
    fill: "#C9DEF6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M313.988 201.9L357.638 232.133L376.107 210.302L339.089 172.247L313.988 201.9V201.9Z",
    fill: "#C9DEF6"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.293,
    cy: 185.849,
    rx: 19.5179,
    ry: 19.5073,
    transform: "rotate(-71.334 272.293 185.849)",
    fill: "#C9DEF6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M339.024 180.664L334.255 277.93H263.136L258.367 180.664C258.184 176.928 259.539 173.281 262.116 170.572C264.693 167.863 268.267 166.33 272.005 166.33H325.386C329.123 166.33 332.698 167.863 335.275 170.572C337.852 173.28 339.207 176.928 339.024 180.664Z",
    fill: "#C9DEF6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M334.777 278.415L378.171 428.039H383.157L347.674 278.415H334.777V278.415Z",
    fill: "#0134A0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M289.401 278.415L246.007 428.039H241.021L276.503 278.415H289.401V278.415Z",
    fill: "#0134A0"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 312.09,
    cy: 257.073,
    rx: 73.0778,
    ry: 73.1277,
    fill: "#000B64"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M323.94 211.039H300.24C298.929 211.041 297.672 210.521 296.745 209.594C295.818 208.667 295.297 207.409 295.297 206.098V206.098C295.297 203.369 297.508 201.157 300.235 201.157H323.935C325.244 201.157 326.5 201.677 327.426 202.604C328.352 203.531 328.872 204.787 328.872 206.098V206.098C328.872 208.825 326.665 211.037 323.94 211.039V211.039Z",
    fill: "#C9DEF6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M265.826 98.5938V110.178C265.823 111.052 265.931 111.923 266.148 112.769H287.927V86.9029H277.51C274.411 86.9018 271.439 88.1332 269.248 90.3259C267.056 92.5185 265.825 95.4928 265.826 98.5938V98.5938Z",
    fill: "#8896AA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M325.087 128.791H302.697V92.1144H310.087C318.371 92.1144 325.087 98.8347 325.087 107.125V128.791Z",
    fill: "#8896AA"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M267.497 110.287H290.649C299.698 110.276 307.031 102.938 307.041 93.8826C307.073 91.0771 305.595 88.471 303.172 87.059C300.75 85.647 297.755 85.647 295.333 87.059C292.91 88.471 291.432 91.0771 291.464 93.8826C291.463 94.3328 291.099 94.6976 290.649 94.6982H267.497V110.287Z",
    fill: "#8896AA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M275.77 102.49H287.777C290.58 102.522 293.185 101.044 294.596 98.6193C296.007 96.1948 296.007 93.1985 294.596 90.774C293.185 88.3496 290.58 86.8711 287.777 86.9028H275.77C272.966 86.8711 270.362 88.3496 268.951 90.774C267.54 93.1985 267.54 96.1948 268.951 98.6193C270.362 101.044 272.966 102.522 275.77 102.49Z",
    fill: "#8896AA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M263.57 107.538C263.571 114.028 268.828 119.288 275.313 119.289C281.799 119.289 287.926 114.027 287.926 107.538C287.926 101.049 281.796 95.7859 275.313 95.7859C272.199 95.7859 269.212 97.0241 267.009 99.2281C264.807 101.432 263.57 104.421 263.57 107.538Z",
    fill: "#8896AA"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 307.987,
    y: 116.341,
    width: 32.4529,
    height: 12.1783,
    transform: "rotate(-180 307.987 116.341)",
    fill: "#8896AA"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 307.055,
    y: 131.713,
    width: 25.0699,
    height: 15.5336,
    transform: "rotate(-180 307.055 131.713)",
    fill: "#8896AA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M311.416 153.467L299.116 153.467C292.882 153.465 287.828 148.408 287.826 142.169V125.448H325.086V139.798C325.083 147.35 318.963 153.469 311.416 153.467V153.467Z",
    fill: "#8896AA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M287.825 125.867H282.661C277.492 125.867 273.302 121.674 273.302 116.502V111.887H287.825V125.867Z",
    fill: "#8896AA"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 282.665,
    y: 158.847,
    width: 34.9999,
    height: 10.9725,
    fill: "#C9DEF6"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M281.985 137.43H276.143V125.739H281.985C285.211 125.739 287.826 128.356 287.827 131.584V131.584C287.827 134.813 285.211 137.43 281.985 137.43V137.43Z",
    fill: "#E6BBA6"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 64.3721,
    y: 111.145,
    width: 101.185,
    height: 63.2951,
    fill: "white"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.5867,
    cy: 120.719,
    rx: 4.03099,
    ry: 4.03374,
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.1758 120.72C94.1763 123.157 96.1512 125.132 98.5868 125.132C101.021 125.128 102.994 123.154 102.996 120.718C102.995 118.281 101.02 116.305 98.5848 116.306C96.1492 116.306 94.1752 118.283 94.1758 120.72ZM95.2097 119.319C95.7756 117.953 97.1083 117.062 98.5864 117.062C100.603 117.066 102.236 118.7 102.239 120.718C102.24 122.197 101.35 123.531 99.9842 124.097C98.6187 124.663 97.0468 124.35 96.0016 123.304C94.9565 122.258 94.6439 120.686 95.2097 119.319Z",
    fill: "#055CC0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.88 122.631H141.363V118.806H105.88V122.631ZM140.607 121.875H106.636V119.562H140.607V121.875Z",
    fill: "#055CC0"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 74.3213,
    y: 150.354,
    width: 20.847,
    height: 5.27359,
    rx: 2.63679,
    fill: "#C9DEF6"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 101.353,
    y: 150.354,
    width: 20.847,
    height: 5.27359,
    rx: 2.63679,
    fill: "#C9DEF6"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 128.386,
    y: 150.354,
    width: 25.1999,
    height: 5.27359,
    rx: 2.63679,
    fill: "#C9DEF6"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 120.057,
    y: 160.943,
    width: 23.024,
    height: 5.27359,
    rx: 2.63679,
    fill: "#C9DEF6"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 89.7998,
    y: 160.943,
    width: 25.1999,
    height: 5.27359,
    rx: 2.63679,
    fill: "#C9DEF6"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 71.5146,
    y: 160.943,
    width: 13.229,
    height: 5.27359,
    rx: 2.63679,
    fill: "#C9DEF6"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 146.972,
    y: 160.943,
    width: 13.229,
    height: 5.27359,
    rx: 2.63679,
    fill: "#C9DEF6"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 94.1572,
    y: 139.765,
    width: 20.847,
    height: 5.27359,
    rx: 2.63679,
    fill: "#4A90E2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7972 145.417H112.369H112.374C114.038 145.417 115.387 144.067 115.387 142.402C115.387 140.737 114.038 139.387 112.374 139.387H96.7972C95.1331 139.387 93.7842 140.737 93.7842 142.402C93.7842 144.067 95.1331 145.417 96.7972 145.417ZM94.5404 142.402C94.5404 141.154 95.5509 140.143 96.7974 140.143H112.374C113.621 140.143 114.631 141.154 114.631 142.402C114.631 143.649 113.621 144.66 112.374 144.66H96.7974C95.5509 144.66 94.5404 143.649 94.5404 142.402Z",
    fill: "#055CC0"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 119.521,
    y: 139.765,
    width: 37.1709,
    height: 5.27359,
    rx: 2.63679,
    fill: "#C9DEF6"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 70.9717,
    y: 139.765,
    width: 18.67,
    height: 5.27359,
    rx: 2.63679,
    fill: "#C9DEF6"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 74.3213,
    y: 129.176,
    width: 20.847,
    height: 5.27359,
    rx: 2.63679,
    fill: "#C9DEF6"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 101.856,
    y: 129.176,
    width: 24.1119,
    height: 5.27359,
    rx: 2.63679,
    fill: "#C9DEF6"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 132.656,
    y: 129.176,
    width: 20.847,
    height: 5.27359,
    rx: 2.63679,
    fill: "#C9DEF6"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 165.556,
    y: 178.361,
    width: 27.4509,
    height: 3.91967,
    transform: "rotate(180 165.556 178.361)",
    fill: "#4A90E2"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 138.106,
    y: 178.361,
    width: 17.551,
    height: 3.91967,
    transform: "rotate(180 138.106 178.361)",
    fill: "#000B64"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M166.25 146.854H165.494V111.524H61.1074V110.767H166.25V146.854V146.854Z",
    fill: "#4A90E2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFte5);
export default __webpack_public_path__ + "static/media/FTE5.84111147d991f573f304abebe0cc48f2.svg";
export { ForwardRef as ReactComponent };